import axios from "axios";

export default {
  getsppx(data) {
    return axios.post("/api/get-sppx-user-profile", data);
  },
  updateprofilesppx(data) {
    return axios.post("/api/update-sppx-user-profile", data);
  },
  refreshsppx(data) {
    return axios.post("/api/sppx-refresh-token", data);
  },
  signinsppx(data) {
    return axios.post("/api/sppx-login", data);
  },
  signin(data) {
    return axios.post("/api/signin", data);
  },
  signup(data) {
    return axios.post("/api/signup", data);
  },
  signout() {
    return axios.post("/api/signout");
  },
  me() {
    return axios.get("/api/me");
  },
  get_accreditation_letter() {
    return axios.post("/api/get-accreditation-letter");
  },
  accept_legal_disclosures_for_investor() {
    return axios.post("/api/accept-legal-disclosures-for-investor");
  },

  get_notifications(since) {
    return axios.get("/api/notifications", { params: { since: since } });
  },
  notification_seen(notification_id) {
    return axios.post("/api/notification-seen", {
      notification: notification_id,
    });
  },

  get_home(id, name) {
    return axios.get("/api/homes/get", {
      params: { home_id: id, home_name: name },
    });
  },
  list_home_perks(homeId) {
    return axios.get(`/api/homes/${homeId}/perks`);
  },
  create_home_perk(homeId, data) {
    return axios.post(`/api/homes/${homeId}/perks`, data);
  },
  update_home_perk(homeId, perkId, data) {
    return axios.patch(`/api/homes/${homeId}/perks/${perkId}`, data);
  },
  reorder_home_perks(homeId, ids) {
    return axios.post(`/api/homes/${homeId}/perks/reorder`, { ids });
  },
  archive_home_perk(homeId, perkId) {
    return axios.post(`/api/homes/${homeId}/perks/${perkId}/archive`);
  },
  activate_home_perk(homeId, perkId) {
    return axios.post(`/api/homes/${homeId}/perks/${perkId}/activate`);
  },
  upload_home_perk_image(homeId, perkId, formData) {
    return axios.post(`/api/homes/${homeId}/perks/${perkId}/image`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  admin_list_home_perks(homeId) {
    return axios.get(`/api/admin/homes/${homeId}/perks`);
  },
  admin_list_investment_perks(params = {}) {
    return axios.get(`/api/admin/investment-perks`, { params });
  },
  admin_update_investment_perk(id, data) {
    return axios.patch(`/api/admin/investment-perks/${id}`, data);
  },
  get_investment_perks(investmentId) {
    return axios.get(`/api/investments/${investmentId}/perks`);
  },
  // Wire/check payment instructions for an existing investment (account view),
  // e.g. after a 506(c) hold is released. Returns the same custodianDetails
  // shape checkout uses, or { pending_accreditation: true } while held.
  get_payment_instructions(investmentId) {
    return axios.get(`/api/investment/${investmentId}/payment-instructions`);
  },
  // Reg CF + 506(c) Phase D: admin Bonus-Share rules authoring (story E2).
  admin_get_bonus_share_rules(homeId) {
    return axios.get(`/api/admin/homes/${homeId}/bonus-share-rules`);
  },
  admin_save_bonus_share_rules(homeId, data) {
    return axios.post(`/api/admin/homes/${homeId}/bonus-share-rules`, data);
  },
  admin_copy_bonus_share_rules(homeId, sourceTrack, targetTrack) {
    return axios.post(`/api/admin/homes/${homeId}/bonus-share-rules/copy`, {
      source_track: sourceTrack,
      target_track: targetTrack,
    });
  },
  // Issuer-facing bonus-share rule authoring — ownership-gated
  // counterparts to the admin endpoints above. Same payload shapes;
  // backend routes mirror the admin ones byte-for-byte but accept
  // EditHomePermission OR Admin. Used by BonusSharesAuthoring when
  // issuerMode=true (default false preserves the admin path).
  // Spec: docs/feature-specs/investor-incentives-wizard-step.md.
  get_bonus_share_rules(homeId) {
    return axios.get(`/api/homes/${homeId}/bonus-share-rules`);
  },
  // Public read for the investor-facing offering page. Returns active
  // rules only; no auth required (same pattern as list_home_perks).
  // Used by the InvestorIncentivesPublicDisplay component on
  // HomeProfile.vue so investors can see the bonuses they would earn.
  get_active_bonus_share_rules(homeId) {
    return axios.get(`/api/homes/${homeId}/bonus-share-rules/active`);
  },
  save_bonus_share_rules(homeId, data) {
    return axios.post(`/api/homes/${homeId}/bonus-share-rules`, data);
  },
  copy_bonus_share_rules(homeId, sourceTrack, targetTrack) {
    return axios.post(`/api/homes/${homeId}/bonus-share-rules/copy`, {
      source_track: sourceTrack,
      target_track: targetTrack,
    });
  },
  // Reg CF + 506(c) Phase C: payment_delivery_outbox admin surface.
  admin_list_payment_delivery_outbox(params = {}) {
    return axios.get(`/api/admin/payment-delivery-outbox`, { params });
  },
  admin_redispatch_payment_delivery_outbox(rowId) {
    return axios.post(`/api/admin/payment-delivery-outbox/${rowId}/redispatch`);
  },
  admin_cancel_payment_delivery_outbox(rowId) {
    return axios.post(`/api/admin/payment-delivery-outbox/${rowId}/cancel`);
  },
  like_home(id) {
    return axios.post("/api/homes/like", { home: id });
  },
  unlike_home(id) {
    return axios.post("/api/homes/unlike", { home: id });
  },
  // Home-follow unsubscribe wrappers — spec PR L7 / §8.3.
  // Routes added by L3 (PR #596). Token-gated, no login required;
  // the signed token IS the auth. Both routes are idempotent.
  //
  // GET response: { home_follow_id, home_id, home_name, issuer_name, status }
  //   - 400 → invalid/expired token
  //   - 410 → subscription not found (stale token)
  //
  // POST response: { home_follow_id, status }
  //   - status will be 'unsubscribed' on success (or already was, on re-POST)
  getHomeFollowUnsubscribe(token) {
    return axios.get(`/api/home-follow/unsubscribe/${token}`);
  },
  confirmHomeFollowUnsubscribe(token) {
    return axios.post(`/api/home-follow/unsubscribe/${token}`);
  },
  // Abandoned-cart unsubscribe wrappers — spec §7.3 (CAN-SPAM).
  //   - GET returns { home_name, issuer_name, already_unsubscribed }
  //   - POST flips investor_opted_out_at; idempotent.
  getAbandonedCartUnsubscribe(token) {
    return axios.get(`/api/abandoned-cart/unsubscribe/${token}`);
  },
  confirmAbandonedCartUnsubscribe(token) {
    return axios.post(`/api/abandoned-cart/unsubscribe/${token}`);
  },
  // Offering "Send Updates" wrappers — spec PR U5 / §9.4.
  // Routes added by U4 (PR #606). The public list is auth-free; the
  // create + archive routes require EditHomePermission(home.id) or
  // AdminPermission; the admin route is admin-only.
  getOfferingUpdates(homeId) {
    return axios.get(`/api/homes/${homeId}/updates`);
  },
  createOfferingUpdate(homeId, payload) {
    return axios.post(`/api/homes/${homeId}/updates`, payload);
  },
  archiveOfferingUpdate(homeId, announcementId) {
    return axios.post(
      `/api/homes/${homeId}/updates/${announcementId}/archive`,
    );
  },
  adminGetOfferingUpdates(homeId) {
    return axios.get(`/api/admin/homes/${homeId}/updates`);
  },
  // Autosave draft for the issuer "Send an update" editor. Mirrors the
  // checkout_v2_draft wrappers (get/save/delete). Ownership-gated server
  // side (EditHomePermission(home.id) or AdminPermission).
  getOfferingUpdateDraft(homeId) {
    return axios.get(`/api/homes/${homeId}/updates/draft`);
  },
  saveOfferingUpdateDraft(homeId, payload) {
    return axios.post(`/api/homes/${homeId}/updates/draft`, payload);
  },
  deleteOfferingUpdateDraft(homeId) {
    return axios.delete(`/api/homes/${homeId}/updates/draft`);
  },
  // Abandoned-cart wrappers — spec PR C6 / §8.1 (issuer side)
  // and C7 / §8.2 (admin side). Routes added by C5. Issuer
  // routes require EditHomePermission(home.id) or AdminPermission;
  // admin routes are admin-only. ``params`` for the list calls
  // accepts: status, date_from, date_to, ordering, and (admin
  // only) issuer_company_id — passed straight through to the
  // server-side filter parser.
  getIssuerAbandonedCarts(homeId, params = {}) {
    return axios.get(`/api/homes/${homeId}/abandoned-carts`, {
      params,
    });
  },
  sendIssuerAbandonedCartEmail(homeId, abandonedCartId) {
    return axios.post(
      `/api/homes/${homeId}/abandoned-carts/${abandonedCartId}/send-email`,
    );
  },
  adminGetAbandonedCarts(params = {}) {
    return axios.get(`/api/admin/abandoned-carts`, { params });
  },
  adminSendAbandonedCartEmail(abandonedCartId) {
    return axios.post(
      `/api/admin/abandoned-carts/${abandonedCartId}/send-email`,
    );
  },
  // ── Marketing pixels (pixels spec Phase 2) ─────────────────────────────
  // Issuer self-service pixel CRUD (ownership-gated server-side). Attestation
  // is the per-user §7c.b acknowledgment; templates are the Locked Rule 204
  // generator (§6c.1). Privacy endpoints back the consent banner / CCPA.
  getPrivacyDisclosure(homeId) {
    return axios.get(`/api/homes/${homeId}/privacy-disclosure`);
  },
  setPrivacyDisclosure(homeId, payload) {
    return axios.post(`/api/homes/${homeId}/privacy-disclosure`, payload);
  },
  getHomePixels(homeId) {
    return axios.get(`/api/homes/${homeId}/pixels`);
  },
  createHomePixel(homeId, payload) {
    return axios.post(`/api/homes/${homeId}/pixels`, payload);
  },
  updateHomePixel(homeId, pixelId, payload) {
    return axios.patch(`/api/homes/${homeId}/pixels/${pixelId}`, payload);
  },
  disableHomePixel(homeId, pixelId) {
    return axios.post(`/api/homes/${homeId}/pixels/${pixelId}/disable`);
  },
  // Phase 3 (§6b, §13.14): rotate one or more encrypted secret fields on a
  // pixel. ``secrets`` is a per-provider field→value object.
  rotateHomePixelSecret(homeId, pixelId, secrets) {
    return axios.post(
      `/api/homes/${homeId}/pixels/${pixelId}/rotate-secret`, { secrets });
  },
  listIssuerAdCreativeSubmissions(homeId) {
    return axios.get(`/api/homes/${homeId}/ad-creative-review-submissions`);
  },
  getIssuerAdCreativeStatus(homeId) {
    return axios.get(`/api/homes/${homeId}/ad-creative-review-status`);
  },
  submitIssuerAdCreative(homeId, formData) {
    return axios.post(
      `/api/homes/${homeId}/ad-creative-review-submissions`,
      formData,
    );
  },
  // Phase 3 (§7d.c): admin ad-creative review queue.
  adminListAdCreativeReviews(params = {}) {
    return axios.get(`/api/admin/ad-creative-review`, { params });
  },
  adminGetAdCreativeReview(reviewId) {
    return axios.get(`/api/admin/ad-creative-review/${reviewId}`);
  },
  adminApproveAdCreativeReview(reviewId, payload = {}) {
    return axios.post(
      `/api/admin/ad-creative-review/${reviewId}/approve`, payload);
  },
  adminRejectAdCreativeReview(reviewId, decisionReason) {
    return axios.post(`/api/admin/ad-creative-review/${reviewId}/reject`, {
      decision_reason: decisionReason,
    });
  },
  adminListPixelProviderStatuses() {
    return axios.get(`/api/admin/pixels/provider-statuses`);
  },
  adminUpdatePixelProviderStatus(provider, payload) {
    return axios.patch(
      `/api/admin/pixels/provider-statuses/${provider}`,
      payload,
    );
  },
  acceptMarketingComplianceAck(homeId, payload) {
    return axios.post(
      `/api/homes/${homeId}/marketing-compliance-acknowledgment`, payload);
  },
  getMarketingComplianceAck(homeId) {
    return axios.get(
      `/api/homes/${homeId}/marketing-compliance-acknowledgment`);
  },
  getMarketingTemplates(homeId) {
    return axios.get(`/api/homes/${homeId}/marketing/templates`);
  },
  generateMarketingTemplate(homeId, templateId, payload) {
    return axios.post(
      `/api/homes/${homeId}/marketing/templates/${templateId}/generate`,
      payload);
  },
  setMarketingConsent(payload) {
    return axios.post(`/api/privacy/consent`, payload);
  },
  ccpaOptOut() {
    return axios.post(`/api/privacy/ccpa-opt-out`);
  },
  getPrivacyStatus() {
    return axios.get(`/api/privacy/status`);
  },
  // Phase 4.1 (counsel §4.2): investor DSAR marketing-data export. JSON
  // variant returns a downloadable blob; email variant mails a copy.
  downloadMarketingDataExport() {
    return axios.get(`/api/me/marketing-data-export`, {
      params: { format: "json" },
      responseType: "blob",
    });
  },
  emailMarketingDataExport() {
    return axios.get(`/api/me/marketing-data-export`, {
      params: { format: "email" },
    });
  },
  get_listings(params = {}) {
    return axios.get("/api/homes/get-listings", {
      params: { exclude_temporarily_unavailable: true, ...params },
    });
  },
  search_listings(query) {
    return axios.get("/api/homes/search-listings", {
      params: { exclude_temporarily_unavailable: true, ...query },
    });
  },
  get_homes(ids) {
    return axios.post("/api/homes/get-many", { homes: ids });
  },
  update_home(data) {
    return axios.post("/api/homes/update", data);
  },
  adminImportSubscriptionAgreement(homeId, formData) {
    return axios.post(
      `/api/admin/homes/${homeId}/subscription-agreement-import`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  },
  adminPreviewSubscriptionAgreement(homeId, data) {
    return axios.post(
      `/api/admin/homes/${homeId}/subscription-agreement-preview`,
      data,
      { responseType: "blob" }
    );
  },
  update_home_step(data) {
    return axios.post("/api/homes/update-step", data);
  },

  update_user(data) {
    return axios.post("/api/update-user", data);
  },
  // Persist the issuer-side listing-flow T&C acceptance. Idempotent
  // server-side — only sets owner_terms_accepted_at on first call.
  accept_owner_terms() {
    return axios.post("/api/accept-owner-terms");
  },
  update_accreditation(data) {
    return axios.post("/api/update-accreditation", data);
  },
  add_home(data) {
    return axios.post("/api/homes/create", data);
  },

  add_home_activity(data) {
    return axios.post("/api/homes/add-activity", data);
  },

  get_users(query) {
    return axios.get("/api/get-users", { params: query });
  },
  get_investments(query) {
    return axios.get("/api/admin-get-investments", { params: query });
  },
  update_investment_current_status(data) {
    return axios.post("/api/update-investment-current-status", data);
  },
  update_investment_status(data) {
    return axios.post("/api/update-transaction-status", data);
  },
  admin_mark_enterprise_ach_returned(data) {
    return axios.post("/api/admin-enterprise-ach/mark-returned", data);
  },
  get_user(user_id) {
    return axios.get("/api/users/get", { params: { user_id: user_id } });
  },

  add_user(data) {
    return axios.post("/api/add-user", data);
  },
  delete_user(user_id) {
    return axios.post("/api/delete-user", { id: user_id });
  },

  update_profile(data) {
    return axios.post("/api/update-profile", data);
  },

  upload_profile_picture(formData) {
    return axios.post("/api/update-profile-picture", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  update_investor_profile(data) {
    return axios.post("/api/update-investor-profile", data);
  },
  delete_profile_picture() {
    return axios.post("/api/delete-profile-picture");
  },

  send_emails(data) {
    return axios.post("/api/send-emails", data);
  },

  get_cart() {
    return axios.get("/api/get-cart");
  },
  get_checkout_v2_draft(params = {}) {
    return axios.get("/api/checkout-v2-draft", { params });
  },
  save_checkout_v2_draft(data) {
    return axios.post("/api/checkout-v2-draft", data);
  },
  delete_checkout_v2_draft() {
    return axios.delete("/api/checkout-v2-draft");
  },
  send_checkout_v2_resume_link(data) {
    return axios.post("/api/checkout-v2-resume-link", data);
  },
  to_cart(data) {
    return axios.post("/api/to-cart", data);
  },
  update_cart_amount(data) {
    return axios.post("/api/update-cart-amount", data);
  },
  admin_investment_home_dropdown() {
    return axios.get("/api/admin-investment-home-dropdown");
  },
  remove_from_cart(data) {
    return axios.post("/api/remove-from-cart", data);
  },
  submit_cart(data) {
    return axios.post("/api/submit-cart", data);
  },

  cancel_investment(data) {
    return axios.post("/api/cancel-investment", data);
  },

  get_portfolio() {
    return axios.get("/api/get-portfolio");
  },

  get_user_homes() {
    return axios.get("/api/get-user-homes");
  },

  /* get_investments() {
       return axios.get("/api/get-investments");
     },*/
  get_messages() {
    return axios.get("/api/get-messages");
  },
  send_message(recipient_id, text) {
    return axios.post("/api/send-message", {
      recipient: recipient_id,
      message: text,
    });
  },

  message_home(home_id, message, reply_to, disclosure) {
    return axios.post("/api/homes/message", {
      home: home_id,
      message: message,
      reply_to: reply_to,
      disclosure: disclosure,
    });
  },
  get_home_messages(home_id) {
    return axios.get("/api/homes/get-messages", { params: { home: home_id } });
  },
  vote_home_message(message_id) {
    return axios.post("/api/homes/vote-message", { home_message: message_id });
  },

  admin_delete_home(home_id) {
    return axios.post("/api/admin-delete-home", { home: home_id });
  },

  admin_delete_message(message_id) {
    return axios.post("/api/admin-delete-message", { message_id: message_id });
  },

  delete_home(home_id) {
    return axios.post("/api/homes/delete", { home: home_id });
  },

  // Admin-only re-link of a Home's company_id (spec OPD-4). Returns
  // {home_id, old_company_id, new_company_id, changed, audit_id?}.
  admin_update_home_company(home_id, company_id, reason) {
    return axios.post("/api/homes/update-company", {
      home_id,
      company_id,
      reason,
    });
  },

  admin_get_homes(query) {
    return axios.get("/api/admin-get-homes", { params: query });
  },
  admin_get_memos(query) {
    return axios.post("/api/admin-get-memos", query);
  },
  confirm_account(token) {
    return axios.post("/api/confirm/" + token);
  },

  admin_import_nc_investment(data) {
    return axios.post("/api/import-nc-investment", data);
  },

  admin_update_transaction_data(data) {
    return axios.post("/api/update-transaction-data", data);
  },

  admin_update_trade_status(data) {
    return axios.post("/api/update-trade-status", data);
  },

  admin_update_investment_account(data) {
    return axios.post("/api/update-investment-account", data);
  },

  admin_get_investment_activity(home_id) {
    return axios.get("/api/get-investment-activity", {
      params: { home: home_id },
    });
  },

  request_password_reset(email) {
    return axios.post("/api/reset-password", { email: email });
  },
  reset_password(token, new_password) {
    return axios.post("/api/reset/" + token, { password: new_password });
  },

  change_password(old_password, new_password) {
    return axios.post("/api/change-password", {
      old_password: old_password,
      new_password: new_password,
    });
  },

  cancel_issuing(home_id) {
    return axios.post("/api/cancel-issuing", { home: home_id });
  },

  get_hpi_zip() {
    return axios.get("/api/update-hpi-zip");
  },

  update_hpi_zip() {
    return axios.post("/api/update-hpi-zip");
  },

  create_entity(data) {
    return axios.post("/api/create-entity", data);
  },
  create_entity_from_profile() {
    return axios.post("/api/create-entity-from-profile");
  },
  create_associated_person(data) {
    return axios.post("/api/create-associated-person", data);
  },
  create_entity_relationship(data) {
    return axios.post("/api/create-entity-relationship", data);
  },
  create_investor(data) {
    return axios.post("/api/create-investor", data);
  },
  create_subscription_agreement(data) {
    return axios.post("/api/create-subscription-agreement", data);
  },
  validate_investment(data) {
    return axios.post("/api/validate-investment", data);
  },
  checkout_v2_limit_preview(data) {
    return axios.post("/api/checkout-v2-limit-preview", data);
  },
  checkout_v2_policy() {
    return axios.get("/api/checkout-v2-policy");
  },
  sign_subscription_agreement(data) {
    return axios.post("/api/sign-subscription-agreement", data);
  },

  create_party(data) {
    return axios.post("/api/create-party", data);
  },
  create_account(data) {
    return axios.post("/api/create-account", data);
  },
  create_issuer(data) {
    return axios.post("/api/create-issuer", data);
  },
  create_link(data) {
    return axios.post("/api/create-account-party-link", data);
  },
  get_external_plaid(data) {
    return axios.post("/api/get-external-account-plaid", data);
  },
  link_external_plaid(data) {
    return axios.post("/api/link-external-account-plaid", data);
  },
  update_external_plaid(data) {
    return axios.post("/api/update-link-external-account-plaid", data);
  },
  get_nc_party() {
    return axios.get(`/api/get-nc-party`);
  },
  delete_file_video(data) {
    return axios.post("/api//homes/delete-file", data);
  },
  get_nc_account() {
    return axios.get(`/api/get-nc-account`);
  },

  nearby_offerings(home_id) {
    return axios.get("/api/nearby-offerings", {
      params: { home: home_id, exclude_temporarily_unavailable: true },
    });
  },

  offer_funding(home_id) {
    return axios.post("/api/homes/offer-funding", { home_id: home_id });
  },

  follow_user(user_id) {
    return axios.post("/api/users/follow", { user_id: user_id });
  },
  unfollow_user(user_id) {
    return axios.post("/api/users/unfollow", { user_id: user_id });
  },
  get_user_followers(user_id, limit = 15, top_id = null) {
    return axios.get("/api/users/get-followers", {
      params: { user_id: user_id, limit: limit, top_id: top_id },
    });
  },
  rate_user(user_id, score) {
    return axios.post("/api/users/rate", { user_id: user_id, score: score });
  },
  unrate_user(user_id) {
    return axios.post("/api/users/unrate", { user_id: user_id });
  },

  get_strategies(sort_by = "most_popular") {
    return axios.get("/api/get-strategies", { params: { sort_by: sort_by } });
  },
  get_strategy_by_name(name) {
    return axios.get("/api/get-strategy-by-name", { params: { name: name } });
  },
  create_strategy(data) {
    return axios.post("/api/create-strategy", data);
  },
  update_strategy(data) {
    return axios.post("/api/update-strategy", data);
  },
  delete_strategy(id) {
    return axios.post("/api/delete-strategy", { id: id });
  },
  follow_strategy(id) {
    return axios.post("/api/follow-strategy", { id: id });
  },
  unfollow_strategy(id) {
    return axios.post("/api/unfollow-strategy", { id: id });
  },
  get_home_strategies(home_id) {
    return axios.get("/api/get-home-strategies", { params: { home: home_id } });
  },
  set_home_strategies(home_id, strategy_ids) {
    return axios.post("/api/set-home-strategies", {
      home: home_id,
      strategies: strategy_ids,
    });
  },

  get_investors_for_home(home_id) {
    return axios.get("/api/get-investors-for-home", {
      params: { home: home_id },
    });
  },

  get_owner_homes(owner_id) {
    return axios.get("/api/get-owner-homes", {
      params: { owner_id: owner_id },
    });
  },

  search(category, query) {
    return axios.get("/api/search", {
      params: {
        category: category,
        query: query,
        exclude_temporarily_unavailable: true,
      },
    });
  },

  login_as(user_id) {
    return axios.post("/api/login-as", { user: user_id });
  },

  upload_file(formdata) {
    return axios.post("/api/upload-file", formdata, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  generate_signed_url(data) {
    return axios.post("/api/generate-signed-url", data);
  },
  generate_download_url(payload) {
    return axios.post("/api/tax-document/generate-signed-url-for-tax-documents", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  get_my_tax_documents(home_id) {
    return axios.get("/api/tax-document/get-my-tax-documents", {
      params: { home_id: home_id },
    });
  },
  get_home_documents(home_id) {
    return axios.get("/api/homes/get-documents", {
      params: { home_id: home_id },
    });
  },
  upload_home_document(home_id, name, file) {
    let formdata = new FormData();
    formdata.append("file", file);
    formdata.append("data", JSON.stringify({ home_id: home_id, name: name }));
    return axios.post("/api/homes/upload-document", formdata, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  upload_home_picture(home_id, file, pos) {
    let formdata = new FormData();
    formdata.append("data", JSON.stringify({ home_id: home_id }));
    formdata.append("file", file);
    formdata.append("pos", pos);
    return axios.post("/api/homes/upload-picture", formdata, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  mark_seen(notification_id) {
    return axios.post("/api/notification/mark-seen", {
      notification_id: notification_id
    });
  },
  mark_all_seen(user_id) {
    return axios.post("/api/notification/mark-all-seen", {
      user_id: user_id,
    });
  },
  get_notification() {
    return axios.get("/api/notification/get");
  },
  clear_notification(notification_id) {
    return axios.post("/api/notification/clear", {
      notification_id: notification_id,
    });
  },

  clear_all_notifications(user_id) {
    return axios.get("/api/notification/clear-all");
  },
  check_available_name(name) {
    return axios.post("/api/homes/check-available-name", { name: name });
  },

  update_home_picture(id, pos, url) {
    return axios.post("/api/homes/update-picture", {
      pos: pos,
      id: id,
      url: url,
    });
  },

  delete_home_picture(image) {
    const payload =
      image && typeof image === "object"
        ? image.id
          ? { image_id: image.id }
          : { url: image.url }
        : { url: image };
    return axios.post("/api/homes/delete-picture", payload);
  },
  delete_home_document(document_id) {
    return axios.post("/api/homes/delete-document", {
      document_id: document_id,
    });
  },

  create_post(data, img, vid, id) {
    let formdata = new FormData();
    formdata.append(
      "data",
      JSON.stringify({
        text: data,
        allow_likes: true,
        allow_replies: true,
        activity_id: id,
      })
    );

    formdata.append("image.0", img);

    formdata.append("video.0", vid);

    return axios.post("/api/posts/create", formdata, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  like_activity(id) {
    return axios.post("/api/activities/like", { activity_id: id });
  },
  unlike_activity(id) {
    return axios.post("/api/activities/unlike", { activity_id: id });
  },
  get_feed(limit = 15, top_id = null) {
    return axios.get("/api/activities/get-feed", {
      params: { limit: limit, top_id: top_id },
    });
  },
  get_activity_replies(activity_id, limit = 15, top_id = null) {
    return axios.get("/api/activities/get-children", {
      params: {
        activity_id: activity_id,
        typ: "post",
        limit: limit,
        top_id: top_id,
      },
    });
  },
  /* get_post(id) {
        return axios.get("/api/posts/get")
      }
      */

  /* Memo querying functions */
  memo_get(memo_id) {
    return axios.get("/api/memo/get", {
      params: { memo_id: memo_id },
    });
  },
  memo_all(user_id) {
    return axios.get("/api/memo/all", {
      params: { user_id: user_id },
    });
  },

  /* Memo building functions */
  memo_new(context = null) {
    return axios.post("/api/memo/new", { context: context });
  },
  memo_set_context(memo_id, context = null) {
    return axios.post("/api/memo/set-context", {
      memo_id: memo_id,
      context: context,
    });
  },
  memo_set_address(
    memo_id,
    street_address /* string */,
    city /* string */,
    state /* string */,
    zip_code /* string */,
    context = null
  ) {
    return axios.post("/api/memo/set-address", {
      memo_id: memo_id,
      street_address: street_address,
      city: city,
      state: state,
      zip_code: zip_code,
      context: context,
    });
  },
  memo_set_about_info(memo_id, about_info /* json */, context = null) {
    return axios.post("/api/memo/set-about-info", {
      memo_id: memo_id,
      info: about_info,
      context: context,
    });
  },
  memo_set_offering_info(memo_id, offering_info /* json */, context = null) {
    return axios.post("/api/memo/set-offering-info", {
      memo_id: memo_id,
      info: offering_info,
      context: context,
    });
  },
  memo_upload_files(memo_id, namespace, files, context = null) {
    let formdata = new FormData();
    for (let name in files) {
      formdata.append(name, files[name]);
    }
    const args = {
      memo_id: memo_id,
      namespace: namespace,
      context: context,
    };
    formdata.append("data", JSON.stringify(args));
    return axios.post("/api/memo/upload-files", formdata, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  memo_upload_offering_images(memo_id, namespace, images, context = null) {
    let formdata = new FormData();
    images.forEach((image) => {
      formdata.append(image.name, image);
    });
    const args = {
      memo_id: memo_id,
      namespace: namespace,
      context: context,
    };
    formdata.append("data", JSON.stringify(args));
    return axios.post("/api/memo/upload-files", formdata, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  memo_upload_about_files(memo_id, files, context = null) {
    return this.memo_upload_files(memo_id, "about", files, context);
  },
  memo_upload_offering_files(memo_id, files, context = null) {
    this.memo_upload_files(memo_id, "offering", files, context);
  },
  memo_delete_file(memo_id, name, namespace, context = null) {
    return axios.post("/api/memo/delete-file", {
      memo_id: memo_id,
      name: name,
      namespace: namespace,
      context: context,
    });
  },
  memo_subscribe(
    memo_id,
    subscription /* ['memo_monthly', 'memo_yearly'] */,
    context = null
  ) {
    return axios.post("/api/memo/subscribe", {
      memo_id: memo_id,
      subscription: subscription,
      context: context,
    });
  },
  memo_set_status(
    memo_id,
    status /* ['draft', 'completed', 'archived'] */,
    context = null
  ) {
    return axios.post("/api/memo/set-status", {
      memo_id: memo_id,
      status: status,
      context: context,
    });
  },
  memo_complete(memo_id, context = null) {
    return this.memo_set_status(memo_id, "completed", context);
  },
  memo_delete(memo_id) {
    return axios.post("/api/memo/delete", {
      memo_id: memo_id,
    });
  },
  memo_create_update(text, memo_id) {
    return axios.post("/api/memo/create-update", {
      text: text,
      memo_id: memo_id,
    });
  },
  memo_add_notification(memo_id, cta) {
    return axios.post("/api/memo/add-notification", {
      memo_id: memo_id,
      cta: cta,
    });
  },

  memo_get_notifications(memo_id) {
    return axios.get(`/api/memo/get-notifications?memo_id=${memo_id}`);
  },

  memo_get_token(memo_id) {
    return axios.get("/api/memo/get-memo-token", { memo_id: memo_id });
  },

  memo_get_by_token(token, firstname, lastname, email) {
    return axios.post("/api/memo/get-memo-by-token", {
      memo_token: token,
      first_name: firstname,
      last_name: lastname,
      email: email,
    });
  },

  memo_visit(memo_id, firstname, lastname, email) {
    return axios.post("/api/memo/visit", {
      memo_id: memo_id,
      first_name: firstname,
      last_name: lastname,
      email: email,
    });
  },

  get_ga_reports(requests) {
    return axios.post("/api/get-ga-reports", { reportRequests: requests });
  },

  get_company(id) {
    return axios.get(`/api/company-get?id=${id}`);
  },

  get_companies(query) {
    return axios.get("/api/companies/all", { params: query });
  },

  company_create(data, id) {
    return axios.post("/api/companies/create", {
      company_id: id,
      name: data.name,
      primary_color: data.primary_color,
      description: data.description,
      country: data.country,
      city: data.city,
      position: data.position,
      tenure: data.tenure,
      state: data.state,
      url: data.url,
      bio: data.bio,
      logo: data.logo,
      ein: data.EIN,
    });
  },
  company_update(data, id) {
    // return axios.post("/api/companies/update", {
    //   company_id: id,
    //   name: data.name,
    //   name_506c: data.name_506c,
    //   primary_color: data.primary_color,
    //   description: data.description,
    //   country: data.country,
    //   city: data.city,
    //   position: data.position,
    //   tenure: data.tenure,
    //   state: data.state,
    //   url: data.url,
    //   bio: data.bio,
    //   logo: data.logo,
    //   ein: data.ein,
    //   address: data.address,
    //   formation_date: data.formation_date,
    //   jurisdiction: data.jurisdiction,
    //   number_employees: data.number_employees,
    //   zipcode: data.zipcode,
    //   company_type: data.company_type,
    //   fiscal_year_end: data.fiscal_year_end,
    //   webhook_url:data.webhook_url,
    //   webhook_service_enabled:data.webhook_service_enabled
    // });

    const payload = {
      company_id: id,
      name: data.name,
      name_506c: data.name_506c,
      primary_color: data.primary_color,
      description: data.description,
      country: data.country,
      city: data.city,
      position: data.position,
      tenure: data.tenure,
      state: data.state,
      url: data.url,
      bio: data.bio,
      logo: data.logo,
      ein: data.ein,
      address: data.address,
      formation_date: data.formation_date,
      jurisdiction: data.jurisdiction,
      number_employees: data.number_employees,
      zipcode: data.zipcode,
      company_type: data.company_type,
      fiscal_year_end: data.fiscal_year_end
    };

    if (data.custom_webhook) {
      payload.webhook_url = data.webhook_url;
      payload.webhook_service_enabled = data.webhook_service_enabled;
    }

    if (data.pixels_addon) {
      payload.pixels_addon_enabled = data.pixels_addon_enabled;
      payload.per_track_pixels_enabled = data.per_track_pixels_enabled;
    }

    return axios.post("/api/companies/update", payload);
  },

  company_add_officers(data) {
    return axios.post("/api/companies/add-officers", data);
  },

  company_update_officer(data) {
    return axios.post("/api/companies/update-officer", {
      first_name: data.first_name,
      last_name: data.last_name,
      position: data.position,
      tenure: data.tenure,
      previous_employers: data.previous_employers,
      officer_id: data.id,
      linkedin: data.linkedin,
    });
  },

  company_delete_officer(id, url) {
    return axios.post("/api/companies/delete-officer", {
      officer_id: id,
      url: url,
    });
  },

  company_delete_picture(data) {
    return axios.post("/api/companies/delete-officer-picture", {
      officer_id: data.officer_id,
      url: data.url,
    });
  },
  company_update_picture(data) {
    return axios.post("/api/companies/update-officer-picture", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  company_invite(id, data) {
    return axios.post("/api/companies/invite", {
      email: data.email,
      first_name: data.first_name,
      last_name: data.last_name,
      position: data.position,
      tenure: data.tenure,
      picture: data.picture,
      company_id: id,
    });
  },

  remove_company_user(company_id, user_id) {
    return axios.post("/api/companies/remove-user", {
      company_id: company_id,
      user_id: user_id,
    });
  },

  invited(token, password) {
    return axios.post("/api/invited", { token: token, password: password });
  },

  set_regulation(regulation, id) {
    return axios.post("/api/memo/set-regulation", {
      memo_id: id,
      regulation: regulation,
    });
  },

  get_memo_visits(memo_id) {
    return axios.get(`/api/memo/get-visits?memo_id=${memo_id}`);
  },

  get_investor_id() {
    return axios.get(`/api/get-fa-entity-id`);
  },

  process_reservations(data) {
    return axios.post("/api/process-reservations", data);
  },

  checkout_investments(data) {
    return axios.post("/api/checkout-investments", data);
  },
  verify_bank_account(data) {
    return axios.post("/api/verify-bank-account", data);
  },
  reserve_investment(data) {
    return axios.post("/api/reserve-investment", data);
  },

  update_payment_method(data) {
    return axios.post("/api/update-payment-method", data);
  },
  update_enterprise_payment_method(data) {
    return axios.post("/api/update-enterprise-payment-method", data);
  },

  create_offering(data) {
    return axios.post("/api/create-offering-from-home", data);
  },

  create_ach_authorization(data) {
    return axios.post("/api/create-ach-authorization", data);
  },

  perform_kyc_aml_check(data) {
    return axios.post("/api/perform-kyc-aml-check", data);
  },
  sppx_ach_bank(data) {
    return axios.post("/api/sppx-ach-bank", data);
  },
  sppx_ach_bank_list(data) {
    return axios.post("/api/sppx-ach-bank-list", data);
  },
  upload_party_document(data) {
    return axios.post("/api/upload-party-document", data);
  },

  send_kyc_email(data) {
    return axios.post("/api/send-kyc-email", data);
  },

  perform_accreditation_check(data) {
    return axios.post("/api/perform-accreditation-check", data);
  },

  upload_accreditation_document(data) {
    return axios.post("/api/upload-accreditation-document", data);
  },

  remove_accreditation_document() {
    return axios.post("/api/remove-accreditation-document");
  },

  update_investment_type(data) {
    return axios.post("/api/update-investment-type", data);
  },

  // Reg CF + 506(c) slice 4: accreditation review admin queue.
  accreditation_queue(tab) {
    return axios.get("/api/admin/accreditation-queue", { params: { tab } });
  },
  accreditation_decision(data) {
    return axios.post("/api/admin/accreditation-decision", data);
  },

  // Reg CF + 506(c) Phase B: per-issuer accreditation_verification surface.
  accreditation_verification_queue(params) {
    return axios.get("/api/admin/accreditation-verification-queue", { params });
  },
  accreditation_verification_detail(verificationId) {
    return axios.get(`/api/admin/accreditation-verification/${verificationId}`);
  },
  accreditation_verification_decision(data) {
    return axios.post("/api/admin/accreditation-verification-decision", data);
  },
  accreditation_audit_sample(data) {
    return axios.post("/api/admin/accreditation-audit-sample", data, {
      responseType: "blob",
    });
  },

  get_otp_secret() {
    return axios.get("/api/get-otp-secret");
  },

  get_otp_uri() {
    return axios.get("/api/get-otp-uri");
  },

  enable_otp(data) {
    return axios.post("/api/enable-otp", data);
  },

  send_otp_code() {
    return axios.post("/api/send-otp-code");
  },
  get_accreditation() {
    return axios.post("/api/perform-accreditation-status-request");
  },
  create_custom_tab(data) {
    return axios.post("/api/homes/add-tab", data);
  },
  get_custom_tabs(home_id) {
    return axios.get("/api/homes/get-tab", { params: { home: home_id } });
  },
  get_investors_home(data) {
    return axios.get("/api/distribution/investors-for-home", {
      params: data,
    });
  },
  get_running_ledger(params) {
    return axios.post(`/api/distribution/get-running-ledger`, params);
  }, 
  edit_custom_tab(data) {
    return axios.post("/api/homes/update-tab", data);
  },
  delete_custom_tab(data) {
    return axios.post("/api/homes/delete-tab", data);
  },
  upload_file_url() {
    return axios.get("/api/generate-upload-file-url");
  },
  post_investment_announcement(data) {
    return axios.post("/api/post-investment-announcement", data);
  },
  post_distribution_import(data) { 
    return axios.post("/api/distribution/import", data);  
  }, 
  post_distribution_import_preview(data) {
    return axios.post("/api/distribution/import", { ...data, dry_run: true });
  },
  upload_bank_statement(formdata) {
    // Caller is responsible for appending `force=true` to formdata to
    // bypass the A1.3 duplicate-SHA-256 gate; see AdminBankStatementUpload.vue.
    return axios.post("/api/admin/reconciliation/uploads", formdata, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  get_bank_statement_transactions(params) {
    // A1.5 needs-attention cockpit list endpoint.
    return axios.get("/api/admin/reconciliation/transactions", { params });
  },
  run_bank_statement_matcher(uploadId) {
    // A2.2a trigger route; idempotent — only touches UNMATCHED /
    // prior-PROPOSED rows, never operator decisions.
    return axios.post(
      `/api/admin/reconciliation/uploads/${uploadId}/run-matcher`,
    );
  },
  confirm_bank_statement_match(transactionId) {
    // A3.1/A3.2 confirm: route dispatches credit/refund matrix by
    // bank-row direction.
    return axios.post(
      `/api/admin/reconciliation/transactions/${transactionId}/confirm`,
    );
  },
  reject_bank_statement_match(transactionId, reason) {
    // A3.2 reject: clears the proposed match, returns row to UNMATCHED.
    const body = {};
    if (reason) body.reason = reason;
    return axios.post(
      `/api/admin/reconciliation/transactions/${transactionId}/reject`,
      body,
    );
  },
  manual_match_bank_statement(transactionId, investmentId) {
    // A3.2 manual match: operator-picked investment, runs confirm matrix.
    return axios.post(
      `/api/admin/reconciliation/transactions/${transactionId}/manual-match`,
      { investment_id: investmentId },
    );
  },
  manual_match_bank_statement_multi(transactionId, investmentIds) {
    // Multi-investor manual match for ACH batches. The endpoint
    // accepts a list, runs the matrix per investment, and returns
    // {per_investment: [...], refused: [...]} so the cockpit can
    // show "5 confirmed, 1 skipped".
    return axios.post(
      `/api/admin/reconciliation/transactions/${transactionId}/manual-match`,
      { investment_ids: investmentIds },
    );
  },
  revert_bank_statement(transactionId, reason) {
    // Spec A8 revert: reason is required and goes into the audit row.
    return axios.post(
      `/api/admin/reconciliation/transactions/${transactionId}/revert`,
      { reason },
    );
  },
  search_investments_for_match(query, limit = 20) {
    // A3.3 investor lookup feeding the manual-match modal.
    return axios.get("/api/admin/reconciliation/investments/search", {
      params: { q: query, limit },
    });
  },
  // D2 Epic B — closings.
  get_closings_for_home(homeId, filters = {}) {
    return axios.get(`/api/admin/homes/${homeId}/closings`, {
      params: filters,
    });
  },
  get_next_close_number(homeId) {
    return axios.get(`/api/admin/homes/${homeId}/closings/next-number`);
  },
  create_closing(payload) {
    // payload: { home_id, close_date, is_final_closing?, close_number?, notes? }
    return axios.post("/api/admin/closings", payload);
  },
  get_closing_detail(closingId) {
    return axios.get(`/api/admin/closings/${closingId}`);
  },
  update_closing_close_date(closingId, payload) {
    return axios.patch(`/api/admin/closings/${closingId}/close-date`, payload);
  },
  get_closing_assignment_lists(closingId) {
    // B2: returns { assigned, eligible, not_eligible } — feeds the
    // Investments step on the closing detail page.
    return axios.get(
      `/api/admin/closings/${closingId}/investments/eligibility`,
    );
  },
  assign_closing_investments(closingId, items) {
    // items: [{ investment_id, included, defer_reason? }]
    return axios.post(
      `/api/admin/closings/${closingId}/investments`,
      { items },
    );
  },
  get_closing_splits(closingId) {
    // B4: returns { splits, suggested_defaults, sum_percent,
    // closing_state, total_disbursement_cents }.
    return axios.get(`/api/admin/closings/${closingId}/splits`);
  },
  save_closing_splits(closingId, splits) {
    // splits: [{ issuer_split_id?, issuer_entity_name, percentage }]
    return axios.put(
      `/api/admin/closings/${closingId}/splits`,
      { splits },
    );
  },
  // B7 approval signoff.
  get_closing_preflight(closingId) {
    return axios.get(`/api/admin/closings/${closingId}/preflight`);
  },
  approve_closing(closingId, typedInitials) {
    return axios.post(`/api/admin/closings/${closingId}/approve`, {
      typed_initials: typedInitials,
    });
  },
  reopen_closing(closingId, reason) {
    return axios.post(`/api/admin/closings/${closingId}/reopen`, { reason });
  },
  download_closing_pdf(closingId) {
    return axios.get(`/api/admin/closings/${closingId}/pdf`, {
      responseType: "blob",
    });
  },
  freeze_closing_pdf(closingId) {
    return axios.post(`/api/admin/closings/${closingId}/freeze-pdf`);
  },
  get_closing_delivery_defaults(closingId) {
    return axios.get(`/api/admin/closings/${closingId}/delivery-defaults`);
  },
  send_closing_to_bank(closingId, payload) {
    return axios.post(`/api/admin/closings/${closingId}/send-to-bank`, payload);
  },
  send_closing_to_issuer(closingId, payload) {
    return axios.post(`/api/admin/closings/${closingId}/send-to-issuer`, payload);
  },
  update_closing_fees(closingId, payload) {
    return axios.patch(`/api/admin/closings/${closingId}/fees`, payload);
  },
  update_closing_investment_fees(closingInvestmentId, payload) {
    return axios.patch(
      `/api/admin/closing-investments/${closingInvestmentId}/fees`,
      payload,
    );
  },
  list_closing_wire_instructions(closingId) {
    return axios.get(`/api/admin/closings/${closingId}/wire-instructions`);
  },
  list_closing_saved_payout_profiles(closingId) {
    return axios.get(`/api/admin/closings/${closingId}/saved-payout-profiles`);
  },
  create_closing_wire_instruction(closingId, payload) {
    return axios.post(
      `/api/admin/closings/${closingId}/wire-instructions`,
      payload,
    );
  },
  update_wire_instruction(wireInstructionId, payload) {
    return axios.put(
      `/api/admin/wire-instructions/${wireInstructionId}`,
      payload,
    );
  },
  attach_split_wire_instruction(closingIssuerSplitId, wireInstructionId) {
    return axios.put(
      `/api/admin/closing-issuer-splits/${closingIssuerSplitId}/wire-instruction`,
      { wire_instruction_id: wireInstructionId },
    );
  },
  apply_saved_payout_profile_to_split(closingIssuerSplitId, profileId) {
    return axios.post(
      `/api/admin/closing-issuer-splits/${closingIssuerSplitId}/apply-saved-payout-profile`,
      { issuer_payout_profile_id: profileId },
    );
  },
  request_closing_wire_instruction(closingId, payload) {
    return axios.post(
      `/api/admin/closings/${closingId}/wire-instruction-requests`,
      payload,
    );
  },
  approve_wire_instruction(wireInstructionId) {
    return axios.post(
      `/api/admin/wire-instructions/${wireInstructionId}/approve`,
    );
  },
  reject_wire_instruction(wireInstructionId, reason) {
    return axios.post(
      `/api/admin/wire-instructions/${wireInstructionId}/reject`,
      { reason },
    );
  },
  admin_wire_instruction_review_queue(params = {}) {
    return axios.get("/api/admin/wire-instructions/review-queue", {
      params,
    });
  },
  update_distribution_status(data) {
    return axios.post("/api/distribution/update-status", data);
  },
  post_investment_tax_upload_document(data) {
    return axios.post("/api/tax-document/post-investment-tax-upload-document", data);
  },
  generate_investment_tax_upload_url(data) {
    return axios.post("/api/tax-document/generate-investment-tax-upload-url", data);
  },
  get_all_investors(data) {
    return axios.post("/api/distribution/get-all-investors", data);
  },
  getAnnouncements(query) {
    return axios.get("/api/investment-announcements", { params: query });
  },
  getDistributionInvestors(query) {
    return axios.get("/api/distribution/investors", { params: query });
  },
  sendDistribution(data) {
    return axios.post("/api/distribution/send", data);
  },
  updateDistributionStatus(data) {
    return axios.post("/api/distribution/update-status", data);
  },
  editDistribution(data) {
    return axios.patch("/api/distribution/update", data);
  },
  createDistributionPhase(data) {
    return axios.post("/api/distribution/create-phase", data);
  },
  getDistributionPhases(params) {
    return axios.get('/api/distribution/phases', { params });
  },
  getDistributionSummary(params) {
    return axios.get(`/api/distribution/summary`, { params });
  },
  getDistributionSummaryByInvestor(params) {
    return axios.get(`/api/distribution/summary-by-investor`, { params });
  },
  createReferralToken(data) {
    return axios.post("/api/referral/tokens", data);
  },
  listReferralTokens(params) {
    return axios.get("/api/referral/tokens", { params });
  },
  updateReferralToken(tokenId, data) {
    return axios.patch(`/api/referral/tokens/${tokenId}`, data);
  },
  captureReferralToken(token) {
    return axios.get("/api/referral/capture", { params: { token } });
  },
  getReferralStats(params) {
    return axios.get("/api/referral/stats", { params });
  },
  get_all_investors_tax_document(data) {
    return axios.post("/api/tax-document/get-investors-with-tax-document", data);
  },
  get_announcement_by_id(announcement_id) {
    return axios.get("/api/get-announcement-by-id", { params: { announcement_id } });
  },
  update_announcement_status(data) {
    return axios.patch("/api/update-announcement-archive-status", data);
  },
  getAnnouncementsinvestors(query) {
    return axios.get("/api/investor-announcements", { params: query });
  },
  getDistributions(query) {
    return axios.get("/api/distribution/my-distributions", { params: query });
  },
  getHomeSummary(query) {
    return axios.get("/api/distribution/home-summary", { params: query });
  }, 
  escrow_create(data) {
    return axios.post("/api/escrow-selection", data);
  },
  // Reg CF + 506(c) program, Phase A: per-track Enterprise escrow config.
  getEscrowTrackConfig(homeId) {
    return axios.get(`/api/admin-home/${homeId}/escrow-track-config`);
  },
  saveEscrowTrackConfig(homeId, configs) {
    return axios.post(`/api/admin-home/${homeId}/escrow-track-config`, { configs });
  },
  // Two-track economics program, Phase 3: per-track offering economics.
  getEconomicTrackConfig(homeId) {
    return axios.get(`/api/admin-home/${homeId}/economic-track-config`);
  },
  saveEconomicTrackConfig(homeId, configs) {
    return axios.post(`/api/admin-home/${homeId}/economic-track-config`, { configs });
  },
  // Phase 4: owner-facing read for the issuer ProposeTerms flow. The issuer
  // saves per-track economics by including `economic_track_configs` in the
  // update_home payload (owner-gated), so only a GET is needed here.
  getHomeEconomicTrackConfig(homeId) {
    return axios.get(`/api/homes/${homeId}/economic-track-config`);
  },
  // Reg CF + 506(c) program, Phase D: bonus-share rule authoring (E2) and
  // bonus-share snapshot audit (E6). Rules are content-immutable — edits to
  // content fields are rejected; archive-and-recreate instead.
  getBonusShareRules(homeId) {
    return axios.get(`/api/admin-home/${homeId}/bonus-share-rule`);
  },
  saveBonusShareRule(homeId, rule) {
    return axios.post(`/api/admin-home/${homeId}/bonus-share-rule`, rule);
  },
  archiveBonusShareRule(homeId, ruleId) {
    return axios.post(
      `/api/admin-home/${homeId}/bonus-share-rule/${ruleId}/archive`
    );
  },
  getBonusShareSnapshots(params = {}) {
    return axios.get(`/api/admin/bonus-share-audit`, { params });
  },
  // Phase D (story E3): pre-signature bonus-share preview for checkout.
  bonusSharePreview(data) {
    return axios.post(`/api/bonus-share-preview`, data);
  },
  create_plaid_link(data = {}) {
    return axios.post("/api/plaid-create-link-token", data);
  },
  plaid_set_access_token(data) {
    return axios.post("/api/plaid-set-access-token", data);
  },
  get_account_details(data) {
    return axios.post("/api/get-account-details", data);
  },
  enterprise_bank_accounts_list(params = {}) {
    return axios.get("/api/enterprise-bank-accounts", { params });
  },
  enterprise_bank_accounts_store(data) {
    return axios.post("/api/enterprise-bank-accounts", data);
  },
  enterprise_bank_accounts_update(token, data) {
    return axios.patch(`/api/enterprise-bank-accounts/${token}`, data);
  },
  enterprise_bank_accounts_delete(token) {
    return axios.delete(`/api/enterprise-bank-accounts/${token}`);
  },
  admin_enterprise_bank_accounts_review_queue(params = {}) {
    return axios.get("/api/admin/enterprise-bank-accounts/review-queue", {
      params,
    });
  },
  admin_approve_enterprise_bank_account(token, payload = {}) {
    return axios.post(
      `/api/admin/enterprise-bank-accounts/${token}/approve`,
      payload,
    );
  },
  admin_reject_enterprise_bank_account(token, payload) {
    return axios.post(
      `/api/admin/enterprise-bank-accounts/${token}/reject`,
      payload,
    );
  },
  get_issuer_wire_instruction_request(token) {
    return axios.get(`/api/issuer/wire-instructions/${token}`, {
      params: { format: "json" },
    });
  },
  issuer_payout_profiles_list(params = {}) {
    return axios.get("/api/issuer/payout-profiles", { params });
  },
  refund_actions_required() {
    return axios.get("/api/banking/refund-actions-required");
  },
  use_saved_issuer_payout_profile(token, profileId) {
    return axios.post(`/api/issuer/wire-instructions/${token}/use-profile`, {
      profile_id: profileId,
    });
  },
  submit_issuer_wire_instruction(token, payload) {
    return axios.post(`/api/issuer/wire-instructions/${token}`, payload);
  },
  issuer_closings_list(params = {}) {
    return axios.get("/api/issuer/closings", { params });
  },
  issuer_closings_for_home(homeId, params = {}) {
    return axios.get("/api/issuer/closings", {
      params: { ...params, home_id: homeId },
    });
  },
  issuer_closing_detail(closingId) {
    return axios.get(`/api/issuer/closings/${closingId}`);
  },
  download_issuer_closing_pdf(closingId) {
    return axios.get(`/api/issuer/closings/${closingId}/pdf`, {
      responseType: "blob",
    });
  },
  admin_get_enterprise_bank_config(env = "dev") {
    return axios.get("/api/admin-enterprise-bank-config", { params: { env } });
  },
  admin_update_enterprise_bank_config(payload) {
    return axios.put("/api/admin-enterprise-bank-config", payload);
  },
  admin_get_enterprise_authorized_ddas(env = "dev") {
    return axios.get("/api/admin-enterprise-bank-config/authorized-ddas", {
      params: { env },
    });
  },
  admin_resync_enterprise_authorized_ddas(payload = {}) {
    return axios.post(
      "/api/admin-enterprise-bank-config/authorized-ddas/resync",
      payload,
    );
  },
  admin_add_enterprise_authorized_dda(payload = {}) {
    return axios.post("/api/admin-enterprise-bank-config/authorized-ddas", payload);
  },
  admin_remove_enterprise_authorized_dda(payload = {}) {
    return axios.post("/api/admin-enterprise-bank-config/authorized-ddas/remove", payload);
  },
  admin_get_enterprise_scheduler_config(env = "dev") {
    return axios.get("/api/admin-enterprise-scheduler-config", { params: { env } });
  },
  admin_get_enterprise_scheduler_activity(env = "dev", limit = 15) {
    return axios.get("/api/admin-enterprise-scheduler-activity", { params: { env, limit } });
  },
  admin_get_enterprise_scheduler_runs(env = "dev", limit = 10) {
    return axios.get("/api/admin-enterprise-scheduler-runs", { params: { env, limit } });
  },
  admin_update_enterprise_scheduler_config(payload) {
    return axios.put("/api/admin-enterprise-scheduler-config", payload);
  },
  admin_run_enterprise_scheduler_now(payload = {}) {
    return axios.post("/api/admin-enterprise-scheduler/run-now", payload);
  },
  admin_promote_enterprise_scheduler(payload = {}) {
    return axios.post("/api/admin-enterprise-scheduler/promote", payload);
  },
  admin_get_enterprise_ach_run(runId, env = "dev") {
    return axios.get(`/api/admin-enterprise-ach/runs/${runId}`, { params: { env } });
  },
  admin_list_enterprise_ach_failed_runs(env = "dev", limit = 50) {
    return axios.get("/api/admin-enterprise-ach/runs", { params: { env, limit } });
  },
  admin_list_enterprise_ach_submissions(env = "dev", limit = 20) {
    return axios.get("/api/admin-enterprise-ach/submissions", { params: { env, limit } });
  },
  admin_list_enterprise_ach_run_instructions(runId, env = "dev", limit = 50, cursor = null) {
    const params = { env, limit };
    if (cursor) {
      params.cursor = cursor;
    }
    return axios.get(`/api/admin-enterprise-ach/runs/${runId}/instructions`, { params });
  },
  admin_list_enterprise_ach_action_queue(env = "dev", limit = 50) {
    return axios.get("/api/admin-enterprise-ach/action-queue", { params: { env, limit } });
  },
  admin_list_enterprise_ach_refund_lifecycles(env = "dev", scope = "open", limit = 100) {
    return axios.get("/api/admin-enterprise-ach/refund-lifecycle", {
      params: { env, scope, limit },
    });
  },
  admin_get_enterprise_ach_refund_lifecycle_by_core_investment(coreInvestmentId) {
    return axios.get(
      `/api/admin-enterprise-ach/refund-lifecycle/by-core-investment/${coreInvestmentId}`,
    );
  },
  admin_get_enterprise_ach_refund_lifecycle_by_investment_fa_id(faId) {
    return axios.get(`/api/admin-enterprise-ach/refund-lifecycle/by-investment/${faId}`);
  },
  admin_get_enterprise_ach_investment_chain_by_core_investment(coreInvestmentId) {
    return axios.get(
      `/api/admin-enterprise-ach/investment-chain/by-core-investment/${coreInvestmentId}`,
    );
  },
  admin_get_enterprise_ach_investment_chain_by_fa_id(faId) {
    return axios.get(`/api/admin-enterprise-ach/investment-chain/by-investment/${faId}`);
  },
  admin_list_enterprise_funding_issuers() {
    return axios.get("/api/admin-enterprise-funding/issuers");
  },
  admin_get_enterprise_funding_board(env = "dev", limit = 100, issuerUserId = null) {
    const params = { env, limit };
    if (issuerUserId) {
      params.issuer_user_id = issuerUserId;
    }
    return axios.get("/api/admin-enterprise-funding/board", { params });
  },
  admin_mark_enterprise_submission_funds_received(submissionId, payload = {}) {
    return axios.post(`/api/admin-enterprise-ach/submissions/${submissionId}/funds-received`, payload);
  },
  admin_mark_enterprise_wire_received(investmentId, payload = {}) {
    return axios.post(`/api/admin-enterprise-ach/investments/${investmentId}/wire-received`, payload);
  },
  admin_cancel_enterprise_pre_batch_ach(investmentId, payload = {}) {
    return axios.post(`/api/admin-enterprise-ach/investments/${investmentId}/cancel-before-ach-run`, payload);
  },
  admin_mark_enterprise_refund_completed(investmentId, payload = {}) {
    return axios.post(`/api/admin-enterprise-ach/investments/${investmentId}/refund-completed`, payload);
  },
  // Refund-via-email tracker (slice 5).
  admin_list_refund_requests(scope = "all") {
    return axios.get("/api/admin/refunds/requests", { params: { scope } });
  },
  admin_get_refund_request(rid) {
    return axios.get(`/api/admin/refunds/requests/${rid}`);
  },
  admin_resend_refund_request(rid) {
    return axios.post(`/api/admin/refunds/requests/${rid}/resend`);
  },
  admin_uncancel_refund_request(rid, payload) {
    return axios.post(
      `/api/admin/refunds/requests/${rid}/uncancel`,
      payload || {},
    );
  },
  admin_refund_outbox_status() {
    return axios.get("/api/admin/refunds/outbox/status");
  },
  admin_refund_outbox_drain(batchSize) {
    return axios.post(
      "/api/admin/refunds/outbox/drain",
      batchSize ? { batch_size: batchSize } : {},
    );
  },
  admin_list_refund_recipients() {
    return axios.get("/api/admin/refunds/recipients");
  },
  admin_add_refund_recipient(payload) {
    return axios.post("/api/admin/refunds/recipients", payload);
  },
  admin_deactivate_refund_recipient(rid) {
    return axios.post(`/api/admin/refunds/recipients/${rid}/deactivate`);
  },
  admin_reactivate_refund_recipient(rid) {
    return axios.post(`/api/admin/refunds/recipients/${rid}/reactivate`);
  },
  admin_get_enterprise_ach_submission(submissionId, env = "dev") {
    return axios.get(`/api/admin-enterprise-ach/submissions/${submissionId}`, { params: { env } });
  },
  admin_mark_enterprise_ach_portal_totals_submitted(submissionId, payload = {}) {
    return axios.post(
      `/api/admin-enterprise-ach/submissions/${submissionId}/portal-totals/submitted`,
      payload
    );
  },
  admin_mark_enterprise_ach_portal_totals_verified(submissionId, payload = {}) {
    return axios.post(
      `/api/admin-enterprise-ach/submissions/${submissionId}/portal-totals/verified`,
      payload
    );
  },
  admin_retry_enterprise_ach_run(runId, payload = {}) {
    return axios.post(`/api/admin-enterprise-ach/runs/${runId}/retry`, payload);
  },
  admin_precheck_enterprise_ach_run_retry(runId, payload = {}) {
    return axios.post(`/api/admin-enterprise-ach/runs/${runId}/retry-precheck`, payload);
  },
  admin_release_enterprise_ach_run(runId, payload = {}) {
    return axios.post(`/api/admin-enterprise-ach/runs/${runId}/release`, payload);
  },
  admin_start_enterprise_ach_manual_reconciliation(runId, payload = {}) {
    return axios.post(`/api/admin-enterprise-ach/runs/${runId}/manual-reconciliation/start`, payload);
  },
  admin_resolve_enterprise_ach_manual_reconciliation(runId, payload = {}) {
    return axios.post(`/api/admin-enterprise-ach/runs/${runId}/manual-reconciliation/resolve`, payload);
  },
  admin_verify_enterprise_ach_manual_reconciliation(runId, payload = {}) {
    return axios.post(`/api/admin-enterprise-ach/runs/${runId}/manual-reconciliation/verify`, payload);
  },
  admin_create_enterprise_ach_manual_ack_event(payload = {}) {
    return axios.post("/api/admin-enterprise-ach/ack-events/manual", payload);
  },
  admin_list_enterprise_sftp_files(env = "dev") {
    return axios.get("/api/admin-enterprise-sftp-files", { params: { env } });
  },
  admin_get_enterprise_refund_tracker(env = "dev", params = {}) {
    return axios.get("/api/admin-enterprise-ach/refund-tracker", { params: { env, ...params } });
  },
  admin_get_enterprise_investment_instruction_lookup(coreInvestmentId) {
    return axios.get(`/api/admin-enterprise-ach/investment-instruction-lookup/${coreInvestmentId}`);
  },
  admin_get_browse_visibility() {
    return axios.get('/api/admin-browse-visibility');
  },
  admin_update_browse_visibility(home_id, show_on_browse_page) {
    return axios.post('/api/admin-browse-visibility', { home_id, show_on_browse_page });
  },
  admin_update_home_availability(home_id, data) {
    return axios.post(`/api/admin/homes/${home_id}/availability`, data);
  },
  identity_verification(data) {
    return axios.post("/api/identity-verification", data);
  },
  get_identity_verification() {
    return axios.post("/api/get-identity-verification");
  },
  get_identity_verification_init() {
    return axios.post("/api/get-identity-verification-init");
  },

  // --- Onboarding (Z-3 Spreadsheet Template Import) ---
  getOnboardingTemplateTypes() {
    return axios.get("/api/onboarding/template-types");
  },
  downloadOnboardingTemplate(templateType) {
    return axios.get(`/api/onboarding/templates/${templateType}`, {
      responseType: "blob",
    });
  },
  uploadOnboardingTemplate(file, templateType, homeId) {
    let formdata = new FormData();
    formdata.append("file", file);
    formdata.append("template_type", templateType);
    if (homeId) {
      formdata.append("home_id", homeId);
    }
    return axios.post("/api/onboarding/upload", formdata, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  validateOnboardingImport(importRunId) {
    return axios.post(`/api/onboarding/validate/${importRunId}`);
  },
  confirmOnboardingImport(importRunId) {
    return axios.post(`/api/onboarding/confirm/${importRunId}`);
  },

  // --- Onboarding (Z-1 Dual Path Detection) ---
  detectOnboardingPath(homeId) {
    return axios.get(`/api/onboarding/detect/${homeId}`);
  },

  // --- Onboarding (Z-4 Manual Offering Setup) ---
  getManualDraft(homeId) {
    return axios.get(`/api/onboarding/manual/draft/${homeId}`);
  },
  saveManualStep(stepNumber, data) {
    return axios.post(`/api/onboarding/manual/step/${stepNumber}`, data);
  },

  // --- Onboarding (Z-5 Completeness Checklist) ---
  getOnboardingChecklist(homeId) {
    return axios.get(`/api/onboarding/checklist/${homeId}`);
  },

  // --- Onboarding (Z-2 AI-Assisted Setup) ---
  uploadAIExtraction(file, homeId) {
    let formdata = new FormData();
    formdata.append("file", file);
    if (homeId) formdata.append("home_id", homeId);
    return axios.post("/api/onboarding/ai/upload", formdata, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  getAIExtractionStatus(runId) {
    return axios.get(`/api/onboarding/ai/status/${runId}`);
  },
  getAIExtractionResults(runId) {
    return axios.get(`/api/onboarding/ai/results/${runId}`);
  },
  confirmAIExtraction(runId, data) {
    return axios.post(`/api/onboarding/ai/confirm/${runId}`, data);
  },

  // --- A-1: Team Management ---
  getTeamMembers(accountId) {
    return axios.get("/api/team/members", { params: { account_id: accountId } });
  },
  inviteTeamMember(data) {
    return axios.post("/api/team/invite", data);
  },
  updateTeamMemberRole(memberId, role) {
    return axios.patch(`/api/team/members/${memberId}/role`, { role });
  },
  updateTeamMemberOfferings(memberId, offeringIds) {
    return axios.patch(`/api/team/members/${memberId}/offerings`, {
      offering_ids: offeringIds,
    });
  },
  deactivateTeamMember(memberId) {
    return axios.delete(`/api/team/members/${memberId}`);
  },

  // --- A-2: Approval Workflows ---
  getApprovalConfig(homeId) {
    return axios.get(`/api/approval/config/${homeId}`);
  },
  updateApprovalConfig(homeId, configs) {
    return axios.put(`/api/approval/config/${homeId}`, { configs });
  },
  getApprovalPending(homeId) {
    return axios.get("/api/approval/pending", {
      params: homeId ? { home_id: homeId } : {},
    });
  },
  approveRequest(requestId, reason) {
    return axios.post(`/api/approval/${requestId}/approve`, { reason });
  },
  rejectRequest(requestId, reason) {
    return axios.post(`/api/approval/${requestId}/reject`, { reason });
  },

  // --- B-1: Audit Log ---
  getAuditLog(params) {
    return axios.get("/api/audit/log", { params });
  },
  exportAuditLog(params) {
    return axios.get("/api/audit/export", {
      params,
      responseType: "blob",
    });
  },

  // --- B-2: Compliance & Legal Export ---
  startComplianceExport(data) {
    return axios.post("/api/audit/export", data);
  },
  getComplianceExportStatus(jobId) {
    return axios.get(`/api/audit/export/${jobId}/status`);
  },
  getComplianceExportDownload(jobId) {
    return axios.get(`/api/audit/export/${jobId}/download`);
  },

  // --- C-1: File Security ---
  getFileScanStatus(fileId) {
    return axios.get(`/api/file-security/scan/${fileId}/status`);
  },
  getSecureDownloadUrl(fileId) {
    return axios.get(`/api/file-security/download/${fileId}`);
  },

  // --- C-2: Document Access Tracking ---
  recordDocumentView(documentId, documentType) {
    return axios.post("/api/file-security/access/view", {
      document_id: documentId,
      document_type: documentType,
    });
  },
  recordDocumentDownload(documentId, documentType) {
    return axios.post("/api/file-security/access/download", {
      document_id: documentId,
      document_type: documentType,
    });
  },
  getDocumentAccessAggregate(homeId, documentType) {
    return axios.get("/api/file-security/access/aggregate", {
      params: { home_id: homeId, document_type: documentType },
    });
  },

  // --- D-1: Cap Table ---
  getCapTable(homeId, params) {
    return axios.get(`/api/cap-table/${homeId}`, { params });
  },
  getCapTableEvents(homeId, params) {
    return axios.get(`/api/cap-table/${homeId}/events`, { params });
  },
  initializeCapTable(homeId) {
    return axios.post(`/api/cap-table/${homeId}/initialize`);
  },
  exportCapTable(homeId, params) {
    return axios.get(`/api/cap-table/${homeId}/export`, {
      params,
      responseType: "blob",
    });
  },

  // --- D-2: Ownership Transfers ---
  recordTransfer(homeId, data) {
    return axios.post(`/api/cap-table/${homeId}/transfer`, data);
  },

  // --- D-3: Investment Cancellation ---
  recordCancellation(homeId, data) {
    return axios.post(`/api/cap-table/${homeId}/cancel`, data);
  },

  // --- Cap Table v2 ---
  getCapTableOwnership(homeId, params) {
    return axios.get(`/api/cap-table/${homeId}/ownership`, { params });
  },
  getCapTableStakeholders(homeId, params) {
    return axios.get(`/api/cap-table/${homeId}/stakeholders`, { params });
  },
  createCapTableStakeholder(homeId, data) {
    return axios.post(`/api/cap-table/${homeId}/stakeholders`, data);
  },
  getCapTableShareClasses(homeId) {
    return axios.get(`/api/cap-table/${homeId}/share-classes`);
  },
  createCapTableShareClass(homeId, data) {
    return axios.post(`/api/cap-table/${homeId}/share-classes`, data);
  },
  getCapTableSecurities(homeId, params) {
    return axios.get(`/api/cap-table/${homeId}/securities`, { params });
  },
  issueCapTableSecurity(homeId, data) {
    return axios.post(`/api/cap-table/${homeId}/securities`, data);
  },
  convertCapTableSecurity(homeId, securityId, data) {
    return axios.post(`/api/cap-table/${homeId}/securities/${securityId}/convert`, data);
  },
  getCapTableRounds(homeId) {
    return axios.get(`/api/cap-table/${homeId}/rounds`);
  },
  createCapTableRound(homeId, data) {
    return axios.post(`/api/cap-table/${homeId}/rounds`, data);
  },
  getCapTableImportTemplate(homeId) {
    return axios.get(`/api/cap-table/${homeId}/import/template`, {
      responseType: "blob",
    });
  },
  uploadCapTableImport(homeId, formData) {
    return axios.post(`/api/cap-table/${homeId}/import/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  getCapTableImportExceptions(homeId, batchId) {
    return axios.get(`/api/cap-table/${homeId}/import/exceptions`, {
      params: { batch_id: batchId },
    });
  },
  resolveCapTableImportException(homeId, exceptionId, data) {
    return axios.patch(`/api/cap-table/${homeId}/import/exceptions/${exceptionId}`, data);
  },
  confirmCapTableImport(homeId, batchId) {
    return axios.post(`/api/cap-table/${homeId}/import/confirm`, { batch_id: batchId });
  },
  exportCapTableV2(homeId, params) {
    return axios.get(`/api/cap-table/${homeId}/export`, {
      params,
      responseType: "blob",
    });
  },

  // --- E-1: Compliance Deadlines ---
  getComplianceDeadlines(homeId, params) {
    return axios.get(`/api/compliance/deadlines/${homeId}`, { params });
  },
  createComplianceDeadline(homeId, data) {
    return axios.post(`/api/compliance/deadlines/${homeId}`, data);
  },
  completeComplianceDeadline(deadlineId) {
    return axios.patch(`/api/compliance/deadlines/${deadlineId}/complete`);
  },


  // ═══════════════════════════════════════════════════════════════
  // Investor Documents API (Phase A)
  // ═══════════════════════════════════════════════════════════════
  
  getInvestorDocuments(homeId, page = 1, perPage = 25) {
    return axios.get(`/api/investor-documents/${homeId}`, {
      params: { page, per_page: perPage },
    });
  },
  getDocumentDownloadUrl(source, docId) {
    return axios.get(`/api/investor-documents/download/${source}/${docId}`);
  },
  createDocumentExportZip(homeId) {
    return axios.post('/api/investor-documents/export-zip', { home_id: homeId });
  },
  getDocumentExportStatus(jobId) {
    return axios.get(`/api/investor-documents/export-zip/${jobId}`);
  },
  getMyCapTablePosition(homeId) {
    return axios.get(`/api/cap-table/${homeId}/my-position`);
  },
  markAnnouncementRead(announcementId) {
    return axios.post(`/api/announcement/mark-read/${announcementId}`);
  },


  // ═══════════════════════════════════════════════════════════════
  // Invite System (Phase C)
  // ═══════════════════════════════════════════════════════════════

  sendInvestorInvites(homeId, stakeholderIds = null) {
    return axios.post('/api/investor-documents/invite-investors', {
      home_id: homeId,
      stakeholder_ids: stakeholderIds,
    });
  },
  getInviteStatus(homeId) {
    return axios.get('/api/investor-documents/invite-status', {
      params: { home_id: homeId },
    });
  },
  verifyInviteToken(token) {
    return axios.post('/api/investor-documents/verify-invite', { token });
  },


  // ═══════════════════════════════════════════════════════════════
  // Post-Close Onboarding Setup
  // ═══════════════════════════════════════════════════════════════

  postCloseCreateEntity(data) {
    return axios.post('/api/post-close/create-entity', data);
  },
  postCloseCreateOffering(data) {
    return axios.post('/api/post-close/create-offering', data);
  },

  finalize_closing(
    closingId,
    {
      sendNotifications = true,
      bankDisbursementConfirmed = false,
      bankDisbursementAttestationVersion = null,
    } = {},
  ) {
    return axios.post(`/api/admin/closings/${closingId}/finalize`, {
      send_notifications: sendNotifications,
      bank_disbursement_confirmed: bankDisbursementConfirmed,
      bank_disbursement_attestation_version: bankDisbursementAttestationVersion,
    });
  },
};
